import { environment as workforceEnvironment } from '../../environments/environment';
import { MenuItem } from './menu.item.model';

export interface WorkerMenuSection {
  title: string;
  items: MenuItem[];
}

export const sections: WorkerMenuSection[] = [
  ...workforceEnvironment.firebase.projectId === 'isoharja-demo'
    ? [
        {
          title: 'workforceV2.beta',
          items: [
            {
              icon: 'people-outline',
              name: 'workforceV2.work-days',
              route: '/workforce-v2/work-days',
              exact: true,
            },
          ],
        },
      ]
    : [],
  {
    title: 'nav-item.operational.home',
    items: [{ icon: 'home', name: 'nav.home', route: '/home' }],
  },
  {
    title: 'nav-item.operational.title',
    items: [
      { icon: 'diamond', name: 'sites.tickets', route: '/worker/tickets' },
    ],
  },
  {
    title: 'nav-item.reporting.title',
    items: [
      {
        icon: 'time-outline',
        name: 'site.worktime',
        route: '/worker/timesheets',
      },
      {
        icon: 'cash',
        name: 'nav.userpaycheckworker',
        route: '/worker/paycheck',
      },
    ],
  },
];

export const items: MenuItem[] = sections.flatMap((section) => section.items);

export const workerMenu = {
  sections,
  items,
};
